import React, { useContext, useState } from 'react';
import './Login.css'
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { AuthContext } from '../../contexts/UserContext';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';


const Login = () => {

	const [success, setSuccess] = useState(false)
	const [error, setError] = useState('')
	const [userEmail, setUserEmail] = useState('')

	const { signIn, resetPassword } = useContext(AuthContext)
	const navigate = useNavigate();
	const location = useLocation();
	const from = location.state?.from?.pathname || "/";

	const handleSubmit = (event) => {
		event.preventDefault();
		setError(false)
		const form = event.target;
		const email = form.email.value;
		const password = form.password.value;
		console.log(email, password);
		signIn(email, password)
			.then(result => {
				const user = result.user;
				console.log(user);
				form.reset();
				setSuccess(true)
				navigate(from, { replace: true })
			})
			.catch(error => {
				console.error('error', error);
				setError(error.message)
			})
	}

	const handleEmailBlur = event => {
		const email = event.target.value;
		setUserEmail(email)
	}

	const handleResetPassword = () => {
		if(!userEmail){
			toast.warning('Please Enter your email address')
		}
		resetPassword(userEmail)
		.then(() => {
			toast.success("Password reset email sent. Please Check Your Mail");
		})
		.catch(error => {
			console.error('error', error)
		})
	}

	


	return (
		<div className="hero min-h-screen bg-base-200">
			<ToastContainer position='top-center'></ToastContainer>
			<div className="hero-content flex-col">
				<div className="text-center lg:text-left">
					<h1 className="text-5xl font-bold text-center">Please Login!</h1>
				</div>

				<form onSubmit={handleSubmit} className="card w-full shadow-2xl bg-base-100">
					<div className="card-body">
						<div className="form-control">
							<label className="label">
								<span className="label-text">Email</span>
							</label>
							<input onBlur={handleEmailBlur} name='email' type="email" placeholder="Your Email" className="input input-bordered" required />
						</div>
						<div className="form-control">
							<label className="label">
								<span className="label-text">Password</span>
							</label>
							<input name='password' type="password" placeholder="Your Password" className="input input-bordered" required />
							<label className="label">
								<Link className="label-text-alt link link-hover"><button onClick={handleResetPassword}>Forgot password?</button></Link>
							</label>
							{success && <p className='text-green-500'>User Login Successfully</p>}
							<p className='text-rose-500'>{error}</p>
						</div>
						<div className="form-control mt-6">
							<button className="btn btn-primary">Login</button>
						</div>
						<p className='text-center und'>Don't have an account? <Link className='underline' to={'/register'}>Register</Link></p>
					</div>
				</form>
			</div>
		</div>
	);
};

export default Login;